import React, { useEffect, useState } from "react";
import TornaAlMenu from "../components/TornaAlMenu";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppSponsorsPage() {
  const [sponsors, setSponsors] = useState([]);
  const [name, setName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [description, setDescription] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [buttonLabel, setButtonLabel] = useState("Visita");
  const [sortOrder, setSortOrder] = useState("0");
  const [imageFile, setImageFile] = useState(null);
  const [editingSponsorId, setEditingSponsorId] = useState(null);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [statsPeriod, setStatsPeriod] = useState("30");
  const [sponsorStatsPeriods, setSponsorStatsPeriods] = useState({});
  const [reportSponsor, setReportSponsor] = useState(null);

  const loadSponsors = async () => {
    const res = await authFetch(`${API_URL}/api/app/sponsors/`);
    const data = await res.json().catch(() => ({}));
    if (res.ok) setSponsors(data.sponsors || []);
  };

  useEffect(() => {
    loadSponsors();

    const refreshInterval = setInterval(() => {
      loadSponsors();
    }, 60000);

    return () => clearInterval(refreshInterval);
  }, []);

  const resetForm = () => {
    setName("");
    setContactEmail("");
    setContactPhone("");
    setDescription("");
    setWebsiteUrl("");
    setButtonLabel("Visita");
    setSortOrder("0");
    setImageFile(null);
    setEditingSponsorId(null);
  };

  const saveSponsor = async () => {
    if (!name.trim()) {
      setResult("Inserisci nome sponsor.");
      return;
    }

    if (!contactEmail.trim()) {
      setResult("Inserisci email sponsor.");
      return;
    }

    setLoading(true);
    setResult("Salvataggio sponsor in corso...");

    const formData = new FormData();
    formData.append("name", name.trim());
    formData.append("contact_email", contactEmail.trim());
    formData.append("contact_phone", contactPhone.trim());
    formData.append("description", description);
    formData.append("website_url", websiteUrl);
    formData.append("button_label", buttonLabel || "Visita");
    formData.append("sort_order", sortOrder || "0");

    if (!editingSponsorId) {
      formData.append("is_active", "true");
    }

    if (imageFile) formData.append("image", imageFile);

    const url = editingSponsorId
      ? `${API_URL}/api/app/sponsors/${editingSponsorId}/`
      : `${API_URL}/api/app/sponsors/`;

    const res = await authFetch(url, {
      method: editingSponsorId ? "PATCH" : "POST",
      body: formData,
    });

    const data = await res.json().catch(() => ({}));

    if (res.ok) {
      setResult(
        editingSponsorId
          ? "Sponsor modificato correttamente."
          : "Sponsor salvato."
      );
      resetForm();
      loadSponsors();
    } else {
      setResult(data.detail || "Errore salvataggio sponsor.");
    }

    setLoading(false);
  };

  const editSponsor = (s) => {
    setEditingSponsorId(s.id);
    setName(s.name || "");
    setContactEmail(s.contact_email || "");
    setContactPhone(s.contact_phone || "");
    setDescription(s.description || "");
    setWebsiteUrl(s.website_url || "");
    setButtonLabel(s.button_label || "Visita");
    setSortOrder(String(s.sort_order ?? 0));
    setImageFile(null);
    setResult(`Modifica sponsor: ${s.name}`);

    setTimeout(() => {
      document
        .getElementById("sponsor-form")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  const normalizeSponsorUrl = (value) => {
    const url = String(value || "").trim();

    if (!url) return "";

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return `https://${url}`;
  };

  const toggleSponsor = async (s) => {
    const formData = new FormData();
    formData.append("is_active", String(!s.is_active));

    const res = await authFetch(`${API_URL}/api/app/sponsors/${s.id}/`, {
      method: "PATCH",
      body: formData,
    });

    if (res.ok) loadSponsors();
  };

  const runSponsorAction = async (s, action) => {
    let message = "";

    if (action === "mark_paid") {
      message = `Segnare "${s.name}" come PAGATO? I 12 mesi NON partiranno ancora.`;
    } else if (action === "mark_unpaid") {
      message = `Segnare "${s.name}" come NON PAGATO?`;
    } else if (action === "activate") {
      message = `Attivare ORA 12 mesi di sponsorizzazione per "${s.name}"?`;
    } else if (action === "renew") {
      message = `Rinnovare "${s.name}" per altri 12 mesi?`;
    }

    const ok = window.confirm(message);
    if (!ok) return;

    const formData = new FormData();
    formData.append("action", action);

    const res = await authFetch(`${API_URL}/api/app/sponsors/${s.id}/`, {
      method: "PATCH",
      body: formData,
    });

    const data = await res.json().catch(() => ({}));

    if (res.ok) {
      if (action === "mark_paid") {
        setResult(`${s.name}: pagamento registrato. In attesa di attivazione.`);
      } else if (action === "mark_unpaid") {
        setResult(`${s.name}: pagamento segnato come non pagato.`);
      } else if (action === "activate") {
        setResult(`${s.name}: sponsorizzazione attivata per 12 mesi.`);
      } else if (action === "renew") {
        setResult(`${s.name}: rinnovo di 12 mesi registrato.`);
      }

      loadSponsors();
    } else {
      setResult(data.detail || "Errore aggiornamento sponsor.");
    }
  };

  const deleteSponsor = async (s) => {
    const ok = window.confirm(`Eliminare sponsor "${s.name}"?`);
    if (!ok) return;

    const res = await authFetch(`${API_URL}/api/app/sponsors/${s.id}/`, {
      method: "DELETE",
    });

    if (res.ok) {
      setResult("Sponsor eliminato.");
      loadSponsors();
    } else {
      setResult("Errore eliminazione sponsor.");
    }
  };

  const totalClicks = sponsors.reduce(
    (sum, s) => sum + Number(s.clicks_total || 0),
    0
  );

  const periodConfig = {
    today: {
      label: "Oggi",
      field: "clicks_today",
    },
    7: {
      label: "Ultimi 7 giorni",
      field: "clicks_last_7_days",
    },
    30: {
      label: "Ultimi 30 giorni",
      field: "clicks_last_30_days",
    },
    365: {
      label: "Ultimi 12 mesi",
      field: "clicks_last_365_days",
    },
    total: {
      label: "Totale",
      field: "clicks_total",
    },
  };

  const selectedPeriod = periodConfig[statsPeriod] || periodConfig["30"];

  const clicksSelectedPeriod = sponsors.reduce(
    (sum, s) => sum + Number(s[selectedPeriod.field] || 0),
    0
  );

  const activeSponsors = sponsors.filter((s) => s.is_active).length;

  const expiringSponsors = sponsors.filter((s) => {
    if (!s.ends_at || !s.is_active) return false;

    const now = new Date();
    const end = new Date(s.ends_at);
    const diff = end.getTime() - now.getTime();
    const days = diff / (1000 * 60 * 60 * 24);

    return days >= 0 && days <= 30;
  }).length;

  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return date.toLocaleDateString("it-IT");
  };

  const sponsorshipStatusLabel = (status) => {
    const labels = {
      DRAFT: "Bozza",
      WAITING_PAYMENT: "In attesa di pagamento",
      WAITING_ACTIVATION: "In attesa di attivazione",
      ACTIVE: "Attivo",
      EXPIRING: "In scadenza",
      EXPIRED: "Scaduto",
    };

    return labels[status] || status || "-";
  };

  const paymentStatusLabel = (status) => {
    const labels = {
      UNPAID: "Non pagato",
      PAID: "Pagato",
    };

    return labels[status] || status || "-";
  };

  const sponsorOverviewStatus = (s) => {
    if (!s.is_active) {
      return {
        label: "Disattivato",
        badgeClass: "bg-secondary",
      };
    }

    if (
      s.payment_status === "PAID" &&
      s.sponsorship_status === "WAITING_ACTIVATION"
    ) {
      return {
        label: "In attesa di attivazione",
        badgeClass: "bg-info text-dark",
      };
    }

    if (s.payment_status !== "PAID" && !s.starts_at && !s.ends_at) {
      return {
        label: "In attesa di pagamento",
        badgeClass: "bg-secondary",
      };
    }

    if (s.ends_at) {
      const now = new Date();
      const end = new Date(s.ends_at);

      if (!Number.isNaN(end.getTime())) {
        const diffMs = end.getTime() - now.getTime();
        const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        if (days < 0) {
          return {
            label: "Scaduto",
            badgeClass: "bg-danger",
          };
        }

        if (days <= 30) {
          return {
            label: `Scade tra ${days} gg`,
            badgeClass: "bg-warning text-dark",
          };
        }
      }
    }

    if (s.sponsorship_status === "ACTIVE") {
      return {
        label: "Attivo",
        badgeClass: "bg-success",
      };
    }

    return {
      label: sponsorshipStatusLabel(s.sponsorship_status),
      badgeClass: "bg-secondary",
    };
  };

  const formatSponsorPrice = (value) => {
    const amount = Number(value);

    if (!Number.isFinite(amount)) return "-";

    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="container py-4">
      <TornaAlMenu />

      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">App Clienti</div>
          <h1 className="fw-bold mb-1">Sponsor & Partner</h1>
          <div className="text-muted">
            Gestisci sponsor visibili nell'app cliente. Nell'app scorreranno automaticamente e saranno cliccabili.
          </div>
        </div>
      </div>

      {result && <div className="alert alert-info">{result}</div>}

      <div className="card border-0 shadow-sm rounded-4 mb-3">
        <div className="card-body py-3">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div>
              <div className="fw-bold">Periodo statistiche</div>
              <div className="small text-muted">
                Seleziona il periodo dei click da analizzare.
              </div>
            </div>

            <div className="btn-group flex-wrap" role="group" aria-label="Periodo statistiche">
              {[
                ["today", "Oggi"],
                ["7", "7 giorni"],
                ["30", "30 giorni"],
                ["365", "12 mesi"],
                ["total", "Totale"],
              ].map(([value, label]) => (
                <button
                  key={value}
                  type="button"
                  className={`btn ${
                    statsPeriod === value
                      ? "btn-dark"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => setStatsPeriod(value)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-6 col-lg-3">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body">
              <div className="text-muted small fw-semibold text-uppercase">
                Sponsor attivi
              </div>
              <div className="display-6 fw-bold mb-0">
                {activeSponsors}
              </div>
            </div>
          </div>
        </div>

        <div className="col-6 col-lg-3">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body">
              <div className="text-muted small fw-semibold text-uppercase">
                Click totali
              </div>
              <div className="display-6 fw-bold mb-0">
                {totalClicks}
              </div>
            </div>
          </div>
        </div>

        <div className="col-6 col-lg-3">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body">
              <div className="text-muted small fw-semibold text-uppercase">
                {selectedPeriod.label}
              </div>
              <div className="display-6 fw-bold mb-0">
                {clicksSelectedPeriod}
              </div>
            </div>
          </div>
        </div>

        <div className="col-6 col-lg-3">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body">
              <div className="text-muted small fw-semibold text-uppercase">
                In scadenza
              </div>
              <div className="display-6 fw-bold mb-0">
                {expiringSponsors}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div>
              <h5 className="fw-bold mb-1">Riepilogo sponsor</h5>
              <div className="small text-muted">
                Situazione commerciale e scadenze a colpo d'occhio.
              </div>
            </div>
          </div>

          {sponsors.length === 0 ? (
            <div className="text-muted">Nessuno sponsor presente.</div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Sponsor</th>
                    <th>Stato</th>
                    <th>Attivazione</th>
                    <th>Scadenza</th>
                    <th>Pagamento</th>
                  </tr>
                </thead>

                <tbody>
                  {sponsors.map((s) => {
                    const overview = sponsorOverviewStatus(s);

                    return (
                      <tr key={`summary-${s.id}`}>
                        <td className="fw-semibold">{s.name}</td>

                        <td>
                          <span className={`badge rounded-pill ${overview.badgeClass}`}>
                            {overview.label}
                          </span>
                        </td>

                        <td>{formatDate(s.starts_at)}</td>

                        <td>{formatDate(s.ends_at)}</td>

                        <td>
                          <div className="fw-semibold">
                            {formatSponsorPrice(s.annual_price)}
                          </div>
                          <div className="small text-muted">
                            {paymentStatusLabel(s.payment_status)}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div
        id="sponsor-form"
        className="card border-0 shadow-sm rounded-4 mb-4"
      >
        <div className="card-body">
          <h5 className="fw-bold mb-3">
            {editingSponsorId ? "Modifica sponsor" : "Nuovo sponsor"}
          </h5>

          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Nome sponsor</label>
              <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">Email sponsor</label>
              <input
                type="email"
                className="form-control"
                placeholder="email@azienda.it"
                required
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">Telefono sponsor</label>
              <input
                type="tel"
                className="form-control"
                placeholder="+39 333 1234567"
                value={contactPhone}
                onChange={(e) => setContactPhone(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold">Link cliccabile</label>
              <input className="form-control" placeholder="https://..." value={websiteUrl} onChange={(e) => setWebsiteUrl(e.target.value)} />
            </div>

            <div className="col-md-2">
              <label className="form-label fw-semibold">Bottone</label>
              <input className="form-control" value={buttonLabel} onChange={(e) => setButtonLabel(e.target.value)} />
            </div>

            <div className="col-md-2">
              <label className="form-label fw-semibold">Ordine</label>
              <input type="number" className="form-control" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} />
            </div>

            <div className="col-12">
              <label className="form-label fw-semibold">Descrizione</label>
              <textarea className="form-control" rows="2" value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>

            <div className="col-12">
              <label className="form-label fw-semibold">Immagine / logo sponsor</label>
              <input type="file" accept="image/*" className="form-control" onChange={(e) => setImageFile(e.target.files?.[0] || null)} />
            </div>
          </div>

          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              className="btn btn-success"
              type="button"
              onClick={saveSponsor}
              disabled={loading}
            >
              {editingSponsorId ? "Salva modifiche" : "Salva sponsor"}
            </button>

            {editingSponsorId && (
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  resetForm();
                  setResult("");
                }}
                disabled={loading}
              >
                Annulla modifica
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Sponsor esistenti</h5>

          {sponsors.length === 0 ? (
            <div className="alert alert-light border mb-0">Nessuno sponsor creato.</div>
          ) : (
            <div className="row g-3">
              {sponsors.map((s) => (
                <div className="col-md-6 col-lg-4" key={s.id}>
                  <div className="border rounded-4 p-3 h-100">
                    {s.image && (
                      <img src={s.image} alt={s.name} className="img-fluid rounded-4 border mb-3" style={{ maxHeight: 160, objectFit: "contain", width: "100%" }} />
                    )}

                    <div className="d-flex justify-content-between align-items-start gap-2">
                      <div>
                        <h6 className="fw-bold mb-1">{s.name}</h6>
                        {s.contact_email && (
                          <div className="small text-muted mb-1">{s.contact_email}</div>
                        )}
                        <div className="small text-muted">{s.description || "-"}</div>
                      </div>
                      <span className={`badge text-nowrap ${s.is_active ? "bg-success" : "bg-secondary"}`}>
                        {s.is_active ? "ATTIVO" : "OFF"}
                      </span>
                    </div>

                    <div className="border rounded-3 p-3 mt-3 bg-light">
                      <div className="d-flex align-items-center justify-content-between gap-3 mb-2">
                        <div className="fw-semibold">Statistiche click</div>
                        <select
                          className="form-select form-select-sm"
                          style={{ width: "auto" }}
                          value={sponsorStatsPeriods[s.id] || "today"}
                          onChange={(e) =>
                            setSponsorStatsPeriods((prev) => ({
                              ...prev,
                              [s.id]: e.target.value,
                            }))
                          }
                        >
                          <option value="today">Oggi</option>
                          <option value="7">Ultimi 7 giorni</option>
                          <option value="30">Ultimi 30 giorni</option>
                          <option value="365">Ultimi 12 mesi</option>
                          <option value="total">Totale</option>
                        </select>
                      </div>

                      <div className="d-flex align-items-end gap-2">
                        <div className="display-6 fw-bold mb-0">
                          {Number(
                            s[
                              periodConfig[sponsorStatsPeriods[s.id] || "today"].field
                            ] || 0
                          )}
                        </div>
                        <div className="text-muted mb-1">click</div>
                      </div>
                    </div>

                    <div className="border rounded-3 p-3 mt-3">
                      <div className="row g-2 small">
                        <div className="col-6">
                          <div className="text-muted">Sponsorizzazione</div>
                          <div className="fw-semibold">
                            {sponsorshipStatusLabel(s.sponsorship_status)}
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="text-muted">Pagamento</div>
                          <div className="fw-semibold">
                            {paymentStatusLabel(s.payment_status)}
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="text-muted">Attivazione</div>
                          <div className="fw-semibold">
                            {formatDate(s.starts_at)}
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="text-muted">Scadenza</div>
                          <div className="fw-semibold">
                            {formatDate(s.ends_at)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {s.website_url && (
                      <a
                        href={normalizeSponsorUrl(s.website_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary btn-sm mt-3"
                      >
                        Apri link
                      </a>
                    )}

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-dark"
                        onClick={() => setReportSponsor(s)}
                      >
                        Report sponsor
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => editSponsor(s)}
                      >
                        Modifica
                      </button>

                      {s.payment_status !== "PAID" && (
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => runSponsorAction(s, "mark_paid")}
                        >
                          Segna pagato
                        </button>
                      )}

                      {s.payment_status === "PAID" &&
                        s.sponsorship_status === "WAITING_ACTIVATION" && (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => runSponsorAction(s, "activate")}
                          >
                            Attiva 12 mesi
                          </button>
                        )}

                      {s.payment_status === "PAID" &&
                        s.sponsorship_status === "ACTIVE" && (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => runSponsorAction(s, "renew")}
                          >
                            Rinnova 12 mesi
                          </button>
                        )}

                      {s.payment_status === "PAID" && (
                        <button
                          className="btn btn-sm btn-outline-warning"
                          onClick={() => runSponsorAction(s, "mark_unpaid")}
                        >
                          Segna non pagato
                        </button>
                      )}

                      <button className="btn btn-sm btn-outline-secondary" onClick={() => toggleSponsor(s)}>
                        {s.is_active ? "Disattiva" : "Attiva"}
                      </button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => deleteSponsor(s)}>
                        Elimina
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {reportSponsor && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
          style={{ background: "rgba(0,0,0,.65)", zIndex: 2000, overflowY: "auto" }}
          onClick={() => setReportSponsor(null)}
        >
          <div
            className="bg-white rounded-4 shadow-lg w-100"
            style={{ maxWidth: "760px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 p-md-5">
              <div className="d-flex justify-content-between align-items-start gap-3 mb-4">
                <div>
                  <div className="text-uppercase small text-muted fw-semibold">Dallo Zio Roby</div>
                  <h2 className="fw-bold mb-1">Report sponsorizzazione</h2>
                  <div className="text-muted">{reportSponsor.name}</div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Chiudi"
                  onClick={() => setReportSponsor(null)}
                />
              </div>

              <div className="border rounded-4 p-3 mb-4">
                <div className="row g-3">
                  <div className="col-6">
                    <div className="small text-muted">Attivazione</div>
                    <div className="fw-semibold">{formatDate(reportSponsor.starts_at)}</div>
                  </div>
                  <div className="col-6">
                    <div className="small text-muted">Scadenza</div>
                    <div className="fw-semibold">{formatDate(reportSponsor.ends_at)}</div>
                  </div>
                </div>
              </div>

              <h5 className="fw-bold mb-3">Risultati click</h5>
              <div className="row g-3">
                {[
                  ["Oggi", "clicks_today"],
                  ["Ultimi 7 giorni", "clicks_last_7_days"],
                  ["Ultimi 30 giorni", "clicks_last_30_days"],
                  ["Ultimi 12 mesi", "clicks_last_365_days"],
                  ["Totale", "clicks_total"],
                ].map(([label, field]) => (
                  <div className="col-6 col-md-4" key={field}>
                    <div className="border rounded-4 p-3 h-100 bg-light">
                      <div className="small text-muted">{label}</div>
                      <div className="fs-2 fw-bold">{Number(reportSponsor[field] || 0)}</div>
                      <div className="small text-muted">click</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-top mt-4 pt-3 small text-muted">
                Report generato il {new Date().toLocaleDateString("it-IT")}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
